import React from 'react';
import { postponements } from '../data/salesPage';
export function NoMondaySection() {
  return <section aria-labelledby="otro-lunes" className="border-t border-ink-line bg-ink-raised" data-id="element-133" data-mp="qmjwjy4w7yke">
      <div className="mx-auto max-w-5xl px-5 py-20 text-center sm:py-28" data-id="element-134" data-mp="15jud3lwe7umz">
        <h2 id="otro-lunes" className="font-display text-5xl font-black uppercase leading-none text-bone sm:text-7xl" data-id="element-135" data-mp="10k81fgw7qmga">
          No necesitás otro lunes
        </h2>
        <p className="mt-8 text-lg text-bone-muted" data-id="element-136" data-mp="cv57b9ke714w">No necesitás esperar:</p>
        <ul className="mx-auto mt-6 flex max-w-3xl flex-wrap justify-center gap-3" data-id="element-137" data-mp="7wlld95stpcj">
          {postponements.map(item => <li key={item} className="rounded-full border border-ink-line px-4 py-2 text-base text-bone-muted line-through decoration-alert/70" data-id="element-138" data-mp="mlrkyy8jthky">
              “{item}”
            </li>)}
        </ul>
        <p className="mt-12 text-xl font-semibold text-bone" data-id="element-139" data-mp="3q7fcqktqyv03">Podés empezar hoy.</p>
        <p className="mx-auto mt-3 max-w-xl text-lg text-bone-muted" data-id="element-140" data-mp="3l9xbzhpvvm36">
          Porque el mejor momento para construir mejores hábitos no es el próximo lunes.
        </p>
        <p className="mt-6 font-display text-7xl font-black uppercase leading-none text-lime sm:text-9xl" data-id="element-141" data-mp="339id90ixr4xf">Es hoy.</p>
      </div>
    </section>;
}